import {
  Directive,
  ElementRef,
  ChangeDetectorRef,
  inject,
  input,
  signal,
  output,
  OnInit,
  OnDestroy,
  InputSignal,
  OutputEmitterRef,
  WritableSignal,
  InjectionToken
} from '@angular/core';
import { SplitButtonsRegistration } from './split-buttons-registration.interface';

@Directive()
export class BaseSplitButtonComponent<T> implements OnInit, OnDestroy {
  readonly value: InputSignal<T | undefined> = input<T>();
  readonly selectChange: OutputEmitterRef<boolean> = output<boolean>();

  readonly active: WritableSignal<boolean> = signal(false);
  readonly parentId: WritableSignal<string | undefined> = signal<string | undefined>(undefined);
  private readonly id: WritableSignal<number | undefined> = signal<number | undefined>(undefined);

  private readonly elementRef: ElementRef = inject(ElementRef);
  private readonly changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);
  private readonly parentSplitButtons: SplitButtonsRegistration<T> | null = inject<SplitButtonsRegistration<T>>(SplitButtonsRegistration as unknown as InjectionToken<SplitButtonsRegistration<T>>, { optional: true });

  ngOnInit(): void {
    this.parentSplitButtons?.registerButton(this);
  }

  ngOnDestroy(): void {
    this.parentSplitButtons?.unregisterButton(this);
  }

  get el(): ElementRef {
    return this.elementRef;
  }

  setParentId(parentId: string): void {
    this.parentId.set(parentId);
    this.changeDetectorRef.detectChanges();
  }

  setButtonId(id: number): void {
    this.id.set(id);
  }

  getButtonId(): number | undefined {
    return this.id();
  }

  setActive(active: boolean): void {
    if (this.active() !== active) {
      this.active.set(active);
      this.changeDetectorRef.markForCheck();
    }
  }

  isActive(): boolean {
    return this.active();
  }

  onSelect(): void {
    this.active.set(true);
    this.selectChange.emit(this.active());
  }

  getValue(): T | undefined {
    return this.value();
  }
}
